import React from 'react';
export function IllustrationGenericCurrency() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "113",
    height: "112",
    viewBox: "0 0 113 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.73767 68.9978C2.22884 47.4011 18.3299 27.7783 40.689 17.5855C58.6665 9.3902 76.9714 14.5607 89.2225 27.4905C104.389 43.4971 95.2004 73.3941 76.1136 89.1036C54.0434 107.269 16.229 93.8543 8.73767 68.9978Z",
    fill: "#E6EFFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: "58.7792",
    cy: "28.8527",
    rx: "12.8112",
    ry: "19.2508",
    transform: "rotate(-40.2539 58.7792 28.8527)",
    fill: "#B75327"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: "63.6562",
    cy: "23.9645",
    rx: "12.8112",
    ry: "19.2508",
    transform: "rotate(-40.2539 63.6562 23.9645)",
    fill: "#FFC85C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6749 35.6855L56.3965 12.3911L62.8885 12.6092L69.974 19.3465L74.5704 27.625L72.6749 35.6855Z",
    fill: "#F2964B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.397 12.3911C58.5883 11.6523 64.5338 12.0145 70.786 19.3737C72.8683 21.8809 76.3236 28.6588 73.4869 35.7128",
    stroke: "#B75327",
    strokeWidth: "2.42388",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: "17.7653",
    cy: "24.1198",
    rx: "17.7653",
    ry: "24.1198",
    transform: "matrix(0.491136 -0.871083 0.878637 0.477491 40.1992 85.5933)",
    fill: "#B75327"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: "17.7653",
    cy: "24.1198",
    rx: "17.7653",
    ry: "24.1198",
    transform: "matrix(0.491136 -0.871083 0.878637 0.477491 43.5098 80.5674)",
    fill: "#FFC85C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9779 88.2111L79.1602 65.3652L84.1431 68.6451L89.8326 79.5319C87.3578 87.1169 84.6787 89.2408 76.9779 88.2111Z",
    fill: "#F2964B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4725 66.4125C82.2318 67.9347 89.6293 72.8991 89.145 80.5791C88.6606 88.2592 81.7268 88.9558 77.9759 88.8675",
    stroke: "#B75327",
    strokeWidth: "2.42388",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6497 64.529C59.8688 65.9399 56.0172 70.1652 59.9334 79.4108",
    stroke: "#FFF5DF",
    strokeWidth: "2.42388",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: "12.3371",
    cy: "16.7499",
    rx: "12.3371",
    ry: "16.7499",
    transform: "matrix(-0.307724 -0.951476 0.946561 -0.322526 11.6494 67.0703)",
    fill: "#B75327"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: "12.3371",
    cy: "16.7499",
    rx: "12.3371",
    ry: "16.7499",
    transform: "matrix(-0.307724 -0.951476 0.946561 -0.322526 10.6377 63.0156)",
    fill: "#FFC85C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.293 49.5208L19.6533 37.6548L23.6733 36.6537L31.9103 38.8717L33.1116 43.6957L30.293 49.5208Z",
    fill: "#F2964B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8642 38.4992C22.4107 37.2958 28.4272 35.8545 32.1212 39.7161C35.8152 43.5778 32.9078 47.4465 31.0975 49.3204",
    stroke: "#B75327",
    strokeWidth: "2.42388",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4573 45.6932C10.8691 47.7773 11.2142 51.7327 17.7787 54.084",
    stroke: "#FFF5DF",
    strokeWidth: "2.42388",
    strokeLinecap: "round"
  }));
}